import { LANDING } from "@/constants/testIds";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

const Footer = () => (
  <footer className="relative bg-white border-t border-slate-200 py-14">
    <div className="max-w-[1600px] mx-auto px-6 sm:px-10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-8">
      <img src="/sumatech-logo.png" alt="SUMATECH INNOVATIONS LLP" className="h-12 w-auto" data-testid={LANDING.footerLogo} />

      <nav className="flex gap-8">
        {LINKS.map((link) => (
          <a
            key={link.href}
            data-testid={`footer-link-${link.label.toLowerCase()}`}
            href={link.href}
            onClick={(e) => {
              e.preventDefault();
              document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
            }}
            className="font-mono text-xs uppercase tracking-[0.15em] text-slate-500 hover:text-[#FF6F3C] transition-colors"
          >
            {link.label}
          </a>
        ))}
      </nav>

      <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">
        &copy; 2026 SUMATECH INNOVATIONS LLP. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
